import axios from "../../utils/axios";
async function fetchList(params) {
    return await axios.get("/single/refunds", { params });
}

async function update(id) {
    return await axios.patch(`/single/refunds/${id}/complete`);
}

export const refundRequestService = {
  fetchList,
    update,
};